import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { formatDate } from '../../helpers/custom';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Tooltip, Chip, Backdrop, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, Box, CardActions, Divider, Typography, FormControl, InputLabel, Select, MenuItem, TextField, ToggleButtonGroup, ToggleButton, OutlinedInput, Autocomplete } from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineOppositeContent, TimelineDot } from '@mui/lab';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, ArrowDownward, ArrowUpward, AccessTime, PersonOutline, HistoryOutlined, CancelPresentationOutlined, DeleteOutline, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import debounce from 'lodash.debounce';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    height: '80%',
    overflowY: 'scroll',
    p: 4,
};


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
    return (
        <Pagination
            count={count}
            page={page}
            onChange={onChange}
            color="primary"
            shape="rounded"
            variant="outlined"
            showFirstButton
            showLastButton
        
        
        
        />
    );
} 

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    bag_distributions: any[];
    rowCount: number;
    pageSize: number;
    routes: any[];
    filter: string;
    filter_routes: any;
    filter_pickup_date?: string | null;
    
    start_date?: string | null;
    end_date?: string | null;
    showChangeBagAgent: boolean;
    agents: any[];
    newBagBatchAgentId: string;
    showRescheduleBagBatch: boolean;
    showStatsModal:  boolean;
    statsCity:  string;
    statsStart:  any;
    statsEnd:  any;
    statsRows:  Array<{ community: string; distributed: number; received: number }>;
    slots: any[];
    newPickupDate: string;
    newSlotId: string;
    showCancelDialog: boolean;
    selected_pod: any;
    showDeleteDialog: boolean;
    selectedBagBatch: any;
    community_id: any;
    routesCities:any[];
    id: any;
    prevDate: any;
    currentPage:number
}

class BagDistribution extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            bag_distributions: [],
            rowCount: 0,
            pageSize: 10,
            routes: [],
            filter: '',
            filter_routes: [],
            routesCities:[],
            filter_pickup_date: null,
            showStatsModal: false,
            statsCity: "",
            statsStart: null,
            statsEnd: null,
            statsRows: [],
            start_date: null,
            end_date: null,
            showChangeBagAgent: false,
            agents: [],
            newBagBatchAgentId: '',
            selected_pod: '',
            showRescheduleBagBatch: false,
            slots: [],
            newPickupDate: '',
            newSlotId: '',
            showCancelDialog: false,
            showDeleteDialog: false,
            selectedBagBatch: {},
            currentPage:0,
            community_id: '',
            id: '',
            prevDate: '',
        }
    }
    public componentDidMount(): void {
        this.fetchBagDistBatchList();
        this.fetchAgents();
        this.fetchSlots();
        this.fetchRoutes();
        this.fetchCities();
    }
    public fetchCities() {
        axios.get(`accessibleHierarchiesList`)
            .then((response: any) => {
                let cities = response.data.data || [];
                this.setState({ routesCities: cities });
            })
            .catch((error) => {
                console.log("City fetch error", error);
            });
    }
    public fetchBagDistBatchList(page: number = 0, limit: number = this.state.pageSize) {
        this.setState({ showLoader: true ,currentPage:page});
        let selectedRoutes: any = [];
        this.state.filter_routes.map((route: any) => {
            selectedRoutes.push(route.id);
        });
        let start_date = (this.state.start_date) ? formatDate(this.state.start_date, 'Y-m-d') : "";
        let end_date = (this.state.end_date) ? formatDate(this.state.end_date, 'Y-m-d') : "";

        let data = { "communities": selectedRoutes, "filter": this.state.filter, "hierarchies": this.props.user.selectedHierarchyIds, "limit": limit, "page": page + 1, "start_date": start_date, "end_date": end_date }
        axios.post(`getAllBagDistBatches`, data, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            this.setState({ showLoader: false });
            let data: any = response.data.data.data;
            let bag_distributions: any = [];
            console.log('data', data);
            data.map((bag_distribution: any) => {
                let customClassNames = [];
                if (bag_distribution.pending_count ) {
                    customClassNames.push('pickupPendingClass');
                } else {
                    customClassNames.push('pickupCompleteClass');
                }
                let pendingPickups = bag_distribution.pending_count ? bag_distribution.pending_count.count : 0;
                let totalPickups = bag_distribution.pickup_count ? bag_distribution.pickup_count.count : 0;
                let completedPickups = bag_distribution.complete_count ? bag_distribution.complete_count.count : 0;
                if (totalPickups != completedPickups && pendingPickups == 0 && totalPickups > 0) {
                    customClassNames.push('pickupPartCompleteClass');
                }
                bag_distributions.push({
                    "id": bag_distribution.id,
                    "route_name": bag_distribution.community.name,
                    "community_id": bag_distribution.community_id,
                    "pickups": {
                        "completed": bag_distribution.complete_count ? bag_distribution.complete_count : 0,
                        "skipped": bag_distribution.skipped_count ? bag_distribution.skipped_count : 0,
                        "cancelled": bag_distribution.cancelled_count ? bag_distribution.cancelled_count : 0,
                        "pending": bag_distribution.pending_count ? bag_distribution.pending_count : 0,
                        "total": bag_distribution.distribution_count ? bag_distribution.distribution_count: 0,
                    },
                    "distribution_date": bag_distribution.distribution_date,
                    "slot_id": (bag_distribution.slot) ? bag_distribution.slot.id : 'NA',
                    "slot": (bag_distribution.slot) ? bag_distribution.slot.text : 'NA',
                    "agent_id": (bag_distribution.agent) ? bag_distribution.agent.id : '',
                    "agent": (bag_distribution.agent) ? bag_distribution.agent.name : 'NA',
                    "is_check_in": bag_distribution.is_check_in,
                    "is_check_out": bag_distribution.is_check_out,
                    "status": bag_distribution.status,
                    "created_at": bag_distribution.created_at,
                    "updated_at": bag_distribution.updated_at,
                    "customClassNames": customClassNames.join(" ")
                });
            });
            this.setState({ bag_distributions: bag_distributions, rowCount: response.data.data.total });
        }).catch((error) => {
            this.setState({
                showLoader: false
            });
            toast.error(error.response.data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public fetchAgents() {
        if (this.props.user.selectedHierarchyIds.length) {
            // this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds}
            axios.get(`allAgentsLite`, { params: options }).then((response: any) => {
                // this.setState({ showLoader: false });
                let agents: any = response.data.data;
                this.setState({ agents: agents });
            });
        }
    }

    public fetchSpecificAgent(){
        if(this.props.user.selectedHierarchyIds.length) {
            this.setState({showLoader: true});
            let options = { "hierarchies": this.props.user.selectedHierarchyIds, "community_id": this.state.community_id}
            axios.get(`allAgentsLite`, { params: options }).then((response: any) => {
                this.setState({showLoader: false});
                let agents: any = response.data.data;
                this.setState({ agents: agents});
            })
        }
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchBagDistBatchList(page, limit);
    }, 800);

    public fetchSlots() {
        if (this.props.user.selectedHierarchyIds.length) {
            // this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds }
            axios.get(`allSlotLite`, { params: options }).then((response: any) => {
                // this.setState({ showLoader: false });
                let slots: any = response.data.data;
                this.setState({ slots: slots });
            });
        }
    }
    public fetchCityStats() {
    if (!this.state.statsCity || !this.state.statsStart || !this.state.statsEnd) {
        toast.error("Select city and dates");
        return;
    }

    const data = {
        hierarchy_id: this.state.statsCity,
        start_date: formatDate(this.state.statsStart, 'Y-m-d'),
        end_date: formatDate(this.state.statsEnd, 'Y-m-d'),
    };

    this.setState({ showLoader: true });

    axios.post("city-stats", data)
        .then((response: any) => {
            let rows = response.data.data;

            const formatted = rows.map((r: any) => ({
                community: r.community_name,
                distributed: r.total_distributed,
                received: r.total_received
            }));

            this.setState({
                statsRows: formatted,
                showLoader: false
            });
        })
        .catch(() => {
            this.setState({ showLoader: false });
            toast.error("Error fetching statistics");
        });
}


    public fetchRoutes() {
        axios.get(`allCommunitiesLite`, {
            params: { hierarchies: this.props.user.selectedHierarchyIds },
        }).then((response) => {
            let data: any = response.data.data;
            let routes: any = [];
            data.map((route: any) => {
                routes[route.id] = {
                    id: route.id,
                    route: route.name,
                    hierarchy_id: route.hierarchy_id,
                    hierarchy_name: route.hierarchy_name,
                };
            });
            this.setState({ routes: routes });
        });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const timelineTypes: any = {
            "pickup": "Cancelled",
            "check_in": "Check In",
            "check_out": "Check Out",
        };

        const openChangeBatchAgent = (pickupDetails: any) => {
            this.setState({
                showChangeBagAgent: true,
                selectedBagBatch: pickupDetails,
                newBagBatchAgentId: pickupDetails.agent_id
            });
        }

        const openRescheduleBatchPickup = (pickupDetails: any) => {
            // console.log("pickupDetails", pickupDetails);
            this.setState({
                showRescheduleBagBatch: true,
                selectedBagBatch: pickupDetails,
                newBagBatchAgentId: pickupDetails.agent_id,
                newPickupDate: pickupDetails.distribution_date,
                newSlotId: pickupDetails.slot_id,
                community_id: pickupDetails.community_id,
                id: pickupDetails.id,
                prevDate: pickupDetails.distribution_date,
            }, () => this.fetchSpecificAgent());
        }

        const openCancelDialog = (pickupDetails: any) => {
            this.setState({
                showCancelDialog: true,
                selectedBagBatch: pickupDetails
            });
        }

        const openDeleteDialog = (pickupDetails: any) => {
            this.setState({
                showDeleteDialog: true,
                selectedBagBatch: pickupDetails
            });
        }
        const printPOD = (() => {
            this.setState({ showLoader: true });
            axios.get(
                'bag/print-pod-v2/' + this.state.selected_pod, 
                {
                params: {
                    community_id: this.state.community_id,
                    start_date: this.state.start_date,
                    end_date: this.state.end_date || null
                },
                responseType: 'blob',
                }
            )
            .then((response: any) => {
                this.setState({ showLoader: false });

                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);

                window.open(url, '_blank');

                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                }, 200);
            })
            .catch((error) => {
                this.setState({ showLoader: false });
                console.log("error logs here", error);

                toast.error(
                    error.response?.data?.message || "Something went wrong",
                    {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    theme: "colored"
                    }
                );
            });
        });
        const handleBatchPickupStateUpdate = (type: string) => {
            this.setState({ showLoader: true });
            let data = {
                agent_id: this.state.selectedBagBatch.agent_id,
                community_pickup_group_id: this.state.selectedBagBatch.id,
                type: type
            };
            axios.post(`batchPickupStateUpdate`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ selectedBagBatch: {}, showLoader: false });
                toast.success(((type == 'check_in') ? 'Check In' : 'Check Out') + ' Successful', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchBagDistBatchList();
            }).catch((error) => {
                this.setState({ selectedBagBatch: {}, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleChangeBatchAgent = (() => {
            this.setState({ showLoader: true });
            let data = {
                agent_id: this.state.newBagBatchAgentId,
                // community_pickup_group_id: this.state.selectedBagBatch.id,
                id: this.state.selectedBagBatch.id,
                hierarchies: this.props.user.selectedHierarchyIds
            };
            axios.post(`changeBagBatchAgent`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showChangeBagAgent: false, newBagBatchAgentId: "", showLoader: false });
                toast.success('Batch Agent Changed Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchBagDistBatchList();
            }).catch((error) => {
                this.setState({ showChangeBagAgent: false, newBagBatchAgentId: "", showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        const handleReschedule = (() => {
            this.setState({ showLoader: true });
            let data = {
                agent_id: this.state.newBagBatchAgentId,
                reschedule_date: this.state.newPickupDate,
                hierarchies: this.props.user.selectedHierarchyIds,
                id: this.state.id,
                reschedule_date_date: this.state.prevDate,
            };
            axios.post(`rescheduleBagBatch`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showRescheduleBagBatch: false, newBagBatchAgentId: "", showLoader: false });
                toast.success( response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchBagDistBatchList();
            }).catch((error) => {
                this.setState({ showRescheduleBagBatch: false, newBagBatchAgentId: "", showLoader: false });
                toast.error(error, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        const handleCancelBagBatch = () => {
            this.setState({ showLoader: true });
            let data = {
                id: this.state.selectedBagBatch.id
            };
            axios.post(`cancelBagBatch`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showCancelDialog: false, selectedBagBatch: {}, showLoader: false });
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchBagDistBatchList();
            }).catch((error) => {
                this.setState({ showCancelDialog: false, selectedBagBatch: {}, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleDeleteBatchPickup = () => {
            this.setState({ showLoader: true });
            let data = {
                batch_id: this.state.selectedBagBatch.id
            };
            axios.post(`deleteBatch`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showDeleteDialog: false, selectedBagBatch: {}, showLoader: false });
                toast.success('Deleted All Pickups Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchBagDistBatchList();
            }).catch((error) => {
                this.setState({ showDeleteDialog: false, selectedBagBatch: {}, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 61
            },
            {
                headerName: t("Community Name"),
                field: "route_name",
                width: 135
            },
            {
                headerName: t("Bags"),
                field: "pickups",
                width: 155,
                renderCell: (params: GridCellParams) => (
                    <div>
                        <Tooltip title="Completed Distribution"><Chip size="small" color="success" className="pickupCountChip" style={{ cursor: 'pointer' }} label={params.row.pickups.completed} /></Tooltip>
                        <Tooltip title="Skipped Distribution"><Chip size="small" color="primary" className="pickupCountChip"style={{ cursor: 'pointer' }} label={params.row.pickups.skipped} /></Tooltip>
                        <Tooltip title="Cancelled Distribution"><Chip size="small" color="error" className="pickupCountChip" style={{ cursor: 'pointer' }} label={params.row.pickups.cancelled} /></Tooltip>
                        <Tooltip title="Pending Distribution"><Chip size="small" color="warning" className="pickupCountChip" style={{ cursor: 'pointer' }} label={params.row.pickups.pending} /></Tooltip><span>/</span>
                        <Tooltip title="Total Distribution"><Chip size="small" color="info" className="pickupCountChip" style={{ cursor: 'pointer' }} label={params.row.pickups.total} /></Tooltip>
                    </div>
                )
            },
            {
                headerName: t("Distribution Date"),
                field: "distribution_date",
                type: "date",
                width: 120
            },
            {
                headerName: t("Agent"),
                field: "agent",
                width: 109
            },
            {
                headerName: t("Added"),
                field: "created_at",
                type: "dateTime",
                width: 151
            },
            {
                headerName: t("Edited"),
                field: "updated_at",
                type: "dateTime",
                width: 151
            },
            {
                headerName: t("Actions"),
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => {
                    let actions: any = [];
                    actions.push(
                        <GridActionsCellItem
                            icon={<PersonOutline />}
                            label={t("Change Batch Agent")}
                            onClick={() => openChangeBatchAgent(params.row)}
                            showInMenu
                            disabled={(params.row.pickups.pending == 0)}
                        />
                    );
                    actions.push(
                        <GridActionsCellItem
                            icon={<HistoryOutlined />}
                            label={t("Reschedule")}
                            onClick={() => openRescheduleBatchPickup(params.row)}
                            showInMenu
                            disabled={(params.row.pickups.pending == 0)}
                        />
                    );
                    actions.push(
                        <GridActionsCellItem
                            icon={<CancelPresentationOutlined />}
                            label={t("Cancel Batch")}
                            onClick={() => openCancelDialog(params.row)}
                            showInMenu
                            disabled={params.row.status == "cancelled"}
                        />
                    );
                    if (params.row.status == "cancelled") {
                        actions.push(
                            <GridActionsCellItem
                                icon={<DeleteOutline />}
                                label={t("Delete Batch")}
                                onClick={() => openDeleteDialog(params.row)}
                                showInMenu
                            />
                        );
                    }
                    return actions;
                    /*return [
                        <GridActionsCellItem
                            icon={<ArrowDownward />}
                            label={(!params.row.is_check_in) ? "Check In" : "Check Out"}
                            onClick={() => openCheckinDialog(params.row)}
                            showInMenu
                        />,
                        <GridActionsCellItem
                            icon={<AccessTime />}
                            label="Timeline"
                            onClick={() => console.log(params.id)}
                            showInMenu
                        />,
                        <GridActionsCellItem
                            icon={<PersonOutline />}
                            label="Change Batch Agent"
                            onClick={() => console.log(params.id)}
                            showInMenu
                        />,
                        <GridActionsCellItem
                            icon={<HistoryOutlined />}
                            label="Reschedule"
                            onClick={() => console.log(params.id)}
                            showInMenu
                        />,
                        <GridActionsCellItem
                            icon={<CancelPresentationOutlined />}
                            label="Cancel Batch"
                            onClick={() => console.log(params.id)}
                            showInMenu
                        />
                    ]*/
                }
            }
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} style={{ paddingTop: '16px' }}  className="mt-3" >
                        <Card style={{height: 700}}>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        <Grid item md={6} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Bag Distribution Batch List")}</Typography>
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <Box display="flex" justifyContent="flex-end">
                                                <Button
                                                    variant="contained"
                                                    sx={{ width: 150 }}
                                                    onClick={() => this.setState({ showStatsModal: true,  statsCity: "",statsStart: null, statsEnd: null,statsRows: [] })}
                                                >
                                                    View Stats
                                                </Button>
                                            </Box>
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <FormControl fullWidth={true} size='small'>
                                                <Autocomplete
                                                    multiple
                                                    id={"communities"}
                                                    options={this.state.routes}
                                                    isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                    getOptionLabel={(option: any) => option.route}
                                                    value={this.state.filter_routes}
                                                    onChange={(e: any, value: any) => this.setState({ filter_routes: value,community_id: value.length ? value[0].id : "" }, () => this.fetchBagDistBatchList())}
                                                    renderInput={(params: any) => (
                                                        <TextField
                                                            {...params}
                                                            label={t("Communities")}
                                                            placeholder={t("Select Communities")}
                                                            size='small'
                                                        />
                                                    )}
                                                    size='small'
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        inputFormat="yyyy-MM-dd"
                                                        mask="____-__-__"
                                                        views={['year', 'month', 'day']}
                                                        renderInput={(props) => <TextField {...props} size='small' />}
                                                        label={t("Start Date")}
                                                        value={this.state.start_date}
                                                        onChange={(newValue: any) => this.setState({ start_date: newValue }, () => this.fetchBagDistBatchList())}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        inputFormat="yyyy-MM-dd"
                                                        mask="____-__-__"
                                                        views={['year', 'month', 'day']}
                                                        renderInput={(props) => <TextField {...props} size='small' />}
                                                        label={t("End Date")}
                                                        value={this.state.end_date}
                                                        onChange={(newValue: any) => this.setState({ end_date: newValue }, () => this.fetchBagDistBatchList())}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        {/* SELECT POD DROPDOWN */}
                                    {/* RIGHT-ALIGNED POD SECTION */}
                                    <Grid item md={4} xs={12}>
                                        <Box 
                                            display="flex" 
                                            justifyContent="flex-end" 
                                            alignItems="center" 
                                            gap={2}   
                                        >
                                            <FormControl size="small" sx={{ width: 200 }}>
                                                <InputLabel id="pod-type-label">{t("Select POD")}</InputLabel>
                                                <Select
                                                    labelId="pod-type-label"
                                                    value={this.state.selected_pod}
                                                    onChange={(e: any) => this.setState({ selected_pod: e.target.value })}
                                                    label={t("Select POD")}
                                                >
                                                    <MenuItem value="club-house">{t("Club House POD")}</MenuItem>
                                                    <MenuItem value="individual-hh">{t("Individual HH POD")}</MenuItem>
                                                </Select>
                                            </FormControl>

                                            <Button
                                                variant="contained"
                                                disabled={
                                                    this.state.filter_routes.length !== 1 || 
                                                    !this.state.community_id ||
                                                    !this.state.start_date ||
                                                    !this.state.selected_pod
                                                }
                                                onClick={() => printPOD()}
                                                sx={{ width: 150 }}
                                            >
                                                {t("Print POD")}
                                            </Button>
                                        </Box>
                                    </Grid>
                                    </Grid>
                                }
                                className="text-left"
                            />
                            <CardContent>
                                <DataGrid
                                    aria-label={t("Batch Pickup List")}
                                    columns={columns}
                                    rows={this.state.bag_distributions}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchBagDistBatchList(page)}
                                    onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }); this.fetchBagDistBatchList(0, newPageSize); }}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    style={{ height: 500 }}
                                    pagination
                                    onRowClick={(params: GridRowParams) => {
                                        //     this.props.history.push('/operations/bag-distribution/group-bag-distribution/' + params.id)
                                        window.open('/operations/bag-distribution/group-bag-distribution/' + params.id, '_blank');
                                    }}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Pagination: () => (
                                            <CustomPagination
                                                count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                                                page={this.state.currentPage+1}
                                                onChange={(event, page) => this.fetchBagDistBatchList(page-1)}
                                              
                                            />
                                        )
                                    }}
                                    className="clickableList"
                                    paginationMode="server"
                                    getRowClassName={(params: any) =>
                                        params.row.customClassNames
                                    }
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showChangeBagAgent}
                    onClose={() => this.setState({ showChangeBagAgent: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={"Change Batch Agent " + ((this.state.selectedBagBatch.route_name) ? ' of ' + this.state.selectedBagBatch.route_name : '')}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showChangeBagAgent: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="payment-agent-label">{t("Batch Agent")} *</InputLabel>
                                            <Select
                                                labelId="payment-agent-label"
                                                value={this.state.newBagBatchAgentId}
                                                onChange={(e) => this.setState({ newBagBatchAgentId: e.target.value })}
                                                displayEmpty
                                                label={t("BatchAgent") + " *"}
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.agents.map((agent: any, key: number) => {
                                                        return (<MenuItem key={key} value={agent.id}>{agent.name}</MenuItem>);
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showChangeBagAgent: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleChangeBatchAgent()}>{t("Update Batch Agent")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showRescheduleBagBatch}
                    onClose={() => this.setState({ showRescheduleBagBatch: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Reschedule Batch") + ((this.state.selectedBagBatch.route_name) ? ' of ' + this.state.selectedBagBatch.route_name : '')}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showRescheduleBagBatch: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="payment-agent-label">{t("Batch Agent")} *</InputLabel>
                                            <Select
                                                labelId="payment-agent-label"
                                                value={this.state.newBagBatchAgentId}
                                                onChange={(e) => this.setState({ newBagBatchAgentId: e.target.value })}
                                                displayEmpty
                                                label={t("Batch Agent") + " *"}
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.agents.map((agent: any, key: number) => {
                                                        return (<MenuItem key={key} value={agent.id}>{agent.name}</MenuItem>);
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("From Date") + " *"}
                                                    value={this.state.newPickupDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ newPickupDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showRescheduleBagBatch: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleReschedule()}>{t("Confirm Reschedule")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Dialog
                    open={this.state.showCancelDialog}
                    onClose={() => this.setState({ showCancelDialog: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to cancel this bag batch ?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showCancelDialog: false })}>{t("Cancel")}</Button>
                        <Button onClick={() => handleCancelBagBatch()} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.showDeleteDialog}
                    onClose={() => this.setState({ showDeleteDialog: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to delete this batch ?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showDeleteDialog: false })}>{t("Cancel")}</Button>
                        <Button onClick={() => handleDeleteBatchPickup()} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
                <Modal
                    open={this.state.showStatsModal}
                    onClose={() => this.setState({ showStatsModal: false })}
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title="View Statistics"
                                action={
                                    <IconButton onClick={() => this.setState({ showStatsModal: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />

                            <CardContent>
                                <Grid container spacing={2}>

                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Select City</InputLabel>
                                            <Select
                                                value={this.state.statsCity}
                                                label="Select City"
                                                onChange={(e) => this.setState({ statsCity: e.target.value })}
                                            >
                                                {this.state.routesCities.map((city: any, idx: number) => (
                                                    <MenuItem key={idx} value={city.id}>
                                                        {city.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item md={4} xs={12}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="From Date"
                                                inputFormat="yyyy-MM-dd"
                                                value={this.state.statsStart}
                                                onChange={(v) => this.setState({ statsStart: v })}
                                                renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid item md={4} xs={12}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="To Date"
                                                inputFormat="yyyy-MM-dd"
                                                value={this.state.statsEnd}
                                                onChange={(v) => this.setState({ statsEnd: v })}
                                                renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid item md={12}>
                                    <Button
                                            variant="contained"
                                            fullWidth
                                            onClick={() => this.fetchCityStats()}
                                        >
                                            Submit
                                    </Button>

                                    </Grid>
                                </Grid>

                                <Box mt={4}>
                                    <TableContainer 
                                        component={Paper} 
                                        elevation={0} 
                                        sx={{ 
                                            border: '1px solid #e0e0e0',
                                            maxHeight: 320,
                                            overflow: 'auto'
                                        }}
                                    >
                                        <Table stickyHeader sx={{ tableLayout: 'fixed' }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 600, borderBottom: '2px solid #ccc', width: '33.33%' }}>
                                                        Community
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ fontWeight: 600, borderBottom: '2px solid #ccc', width: '33.33%' }}>
                                                        Total Bags Distributed
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ fontWeight: 600, borderBottom: '2px solid #ccc', width: '33.33%' }}>
                                                        Total Bags Received
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {this.state.statsRows.length === 0 && (
                                                    <TableRow>
                                                        <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
                                                            No data — click Submit
                                                        </TableCell>
                                                    </TableRow>
                                                )}

                                                {this.state.statsRows.map((row, i) => (
                                                    <TableRow key={i} hover>
                                                        <TableCell>{row.community}</TableCell>
                                                        <TableCell align="center">{row.distributed}</TableCell>
                                                        <TableCell align="center">{row.received}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>

                                <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => this.setState({ showStatsModal: false })}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                        const cityName = this.state.routesCities.find(
                                            c => c.id === this.state.statsCity
                                        )?.name || "";

                                        const fromDate = formatDate(this.state.statsStart, 'Y-m-d');
                                        const toDate = formatDate(this.state.statsEnd, 'Y-m-d');

                                        // ROW 1 → EMPTY A1, TEXT IN B1
                                        let csv = `,City: ${cityName} (${fromDate} to ${toDate})\n`;

                                        // BLANK ROW 2
                                        csv += `\n`;

                                        // ROW 3 → HEADERS
                                        csv += `Community,Total Bags Distributed,Total Bags Received\n`;

                                        // DATA ROWS
                                        this.state.statsRows.forEach(row => {
                                            csv += `${row.community},${row.distributed},${row.received}\n`;
                                        });

                                        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                                        const url = URL.createObjectURL(blob);

                                        const link = document.createElement("a");
                                        link.href = url;
                                        link.download = `city_stats_${cityName}_${fromDate}_${toDate}.csv`;
                                        link.click();

                                        URL.revokeObjectURL(url);
                                    }}
                                    >
                                        Download
                                    </Button>
                                </Box>

                            </CardContent>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(BagDistribution))